import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTreeGridComponent } from './custom-treegrid.component';
import { ButtonModule, SwitchModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { CommandColumnService, FilterService, PageService, SortService } from '@syncfusion/ej2-angular-treegrid';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { CustomDropDownListModule } from '../custom-drop-down-list/custom-drop-down-list.module';
import { ToolbarService, TreeGridModule } from '@syncfusion/ej2-angular-treegrid';



@NgModule({
  declarations: [
    CustomTreeGridComponent
  ],
  imports: [
    CommonModule,
    TreeGridModule,
    ButtonModule,
    SwitchModule,
    CheckBoxModule,
    ToolbarModule,
    TooltipModule,
    CustomDropDownListModule,
    DropDownListModule,
  ],
  providers: [
    SortService,
    PageService,
    ToolbarService,
    FilterService,
    CommandColumnService,
  ],
  exports:[
    CustomTreeGridComponent
  ]
})
export class CustomTreeGridModule { }
